'use strict';
import { StringFilter } from './string-filter';

export class GuidFilter extends StringFilter {
	constructor(options) {
		super(options);

		this.type = 'guid';
		this.operators = this.filterOperatorsFactory.getOperatorsByType('Guid');
	}

	setDefault() {
		this.operator = this.operatorOnForm = this.allOperators.Equals.value;
		this.valueOnForm = '';
	}
}
